<template>
  <div v-click-outside="focousout">
    <label v-if="label" class="input-label" :style="{ paddingLeft: Object.keys($attrs).includes('prepend-icon') ? '42px' : '0px' }">
      {{ label }} <small v-if="showRequired" class="mt-6 error--text">*</small>
    </label>
    <v-text-field
      ref="inputNumber"
      v-bind="$attrs"
      :model-value="modelValue"
      @update:modelValue="valueChanged"
      @focus="focused = true"
      @blur="focousout"
      :hide-details="disableDetails || (focused == true && showNumberIncSuggestion)"
      type="number"
      class="code-clan-number-container"
    >
      <div class="code-clan-number-btn-container">
        <v-icon class="code-clan-number-btn code-clan-number-btn-up" @click="increase">mdi-menu-up</v-icon>
        <v-icon class="code-clan-number-btn code-clan-number-btn-down" @click="decrease">mdi-menu-down</v-icon>
      </div>
      <div v-if="showNumberIncSuggestion && focused" class="input-number-inc-container">
        <div v-for="(item, index) of stepsList" :key="index" class="input-number-inc-box">
          <span class="input-number-inc-btn" outlined @click.prevent="handleIncClick($event, item)">{{ item }}</span>
        </div>
      </div>
    </v-text-field>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: false,
    },
    modelValue: {
      required: true,
      type: Number,
    },
    showRequired: {
      type: Boolean,
      required: false,
    },
    showNumberIncSuggestion: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableDetails: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      stepsList: this.$attrs.step
        ? [Number(this.$attrs.step), (this.$attrs.step as any) * 2, (this.$attrs.step as any) * 3, (this.$attrs.step as any) * 4]
        : [],
      focused: false,
    };
  },
  methods: {
    increase() {
      (this.$refs.inputNumber as any).stepUp();
      this.$emit("update:modelValue", (this.$refs.inputNumber as any).value);
    },
    decrease() {
      (this.$refs.inputNumber as any).stepDown();
      this.$emit("update:modelValue", (this.$refs.inputNumber as any).value);
    },
    focousout() {
      this.focused = false;
      this.$emit("focousout");
    },
    valueChanged(value: any) {
      this.$emit("update:modelValue", value);
    },
    handleIncClick(e: any, item: any) {
      (this.$refs.inputNumber as any).focus();
      const currentValue = this.modelValue ? Number(this.modelValue) : 0;
      this.$emit("update:modelValue", currentValue + item);
    },
  },
  computed: {
    attrs(): any {
      return delete this.$attrs["label"];
    },
  },
});
</script>
